import { styled } from '@linaria/react';
import { motion } from 'framer-motion';
import { Text } from '@daedalus/atlas/Text';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wlajx45",
  propsAsIs: false
});
export const LeftPanel = /*#__PURE__*/styled('div')({
  name: "LeftPanel",
  class: "l1oyz3wd",
  propsAsIs: false
});
export const CarouselWrapper = /*#__PURE__*/styled('div')({
  name: "CarouselWrapper",
  class: "ca3s463",
  propsAsIs: false
});
export const SliderWrapper = /*#__PURE__*/styled('div')({
  name: "SliderWrapper",
  class: "sxv04t0",
  propsAsIs: false
});
const _exp8 = /*#__PURE__*/() => ({
  opacity
}) => opacity;
export const CarouselContainer = /*#__PURE__*/styled('div')({
  name: "CarouselContainer",
  class: "c1qqeio2",
  propsAsIs: false,
  vars: {
    "c1qqeio2-0": [_exp8()]
  }
});
export const CarouselButtonWrapper = /*#__PURE__*/styled('div')({
  name: "CarouselButtonWrapper",
  class: "c19wh8t2",
  propsAsIs: false
});
export const CaptionContentWrapper = /*#__PURE__*/styled('div')({
  name: "CaptionContentWrapper",
  class: "c1y1qqf0",
  propsAsIs: false
});
const _exp17 = /*#__PURE__*/() => Text;
export const ImageNumberIndicator = /*#__PURE__*/styled(_exp17())({
  name: "ImageNumberIndicator",
  class: "iczmg30",
  propsAsIs: true
});
export const RightPanel = /*#__PURE__*/styled('div')({
  name: "RightPanel",
  class: "r1p1t4xh",
  propsAsIs: false
});
export const ImageContainer = /*#__PURE__*/styled('div')({
  name: "ImageContainer",
  class: "i7p78dt",
  propsAsIs: false
});
const _exp23 = /*#__PURE__*/() => motion.div;
export const TopGradient = /*#__PURE__*/styled(_exp23())({
  name: "TopGradient",
  class: "tvma86d",
  propsAsIs: true
});
export const ThumbnailWrapper = /*#__PURE__*/styled('div')({
  name: "ThumbnailWrapper",
  class: "t17igov6",
  propsAsIs: false
});
export const ThumbnailImageWrapper = /*#__PURE__*/styled('div')({
  name: "ThumbnailImageWrapper",
  class: "t2pyqkg",
  propsAsIs: false
});
export const NoMoreImageWrapper = /*#__PURE__*/styled('div')({
  name: "NoMoreImageWrapper",
  class: "n1jcskb8",
  propsAsIs: false
});
export const OfferContentWrapper = /*#__PURE__*/styled('div')({
  name: "OfferContentWrapper",
  class: "o1xfap36",
  propsAsIs: false
});
const LoadingImage = /*#__PURE__*/styled('div')({
  name: "LoadingImage",
  class: "lymycg8",
  propsAsIs: false
});
const _exp49 = /*#__PURE__*/() => LoadingImage;
export const CarouselLoadingItem = /*#__PURE__*/styled(_exp49())({
  name: "CarouselLoadingItem",
  class: "c1oxc57b",
  propsAsIs: true
});
const _exp51 = /*#__PURE__*/() => LoadingImage;
export const ThumbnailLoadingItem = /*#__PURE__*/styled(_exp51())({
  name: "ThumbnailLoadingItem",
  class: "t1juk6xy",
  propsAsIs: true
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");